export enum ProjectPlanEventPosition {
  Start,
  End,
}
